import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core';
import TruncateItemWithTooltip from 'helpers/truncateItemWithTooltip';

import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import * as Types from 'pages/RolesAndPermissions/typings';
import { Theme } from 'styles/ThemeTyping';

interface Props {
  options: Types.FilterField[];
  secondaryOptions?: Types.FilterField[];
  sectionTitle?: string;
  secondarySectionTitle?: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick: (value: Types.FilterField) => void;
}

function SearchableInput({
  options,
  secondaryOptions,
  sectionTitle,
  secondarySectionTitle,
  onSearch,
  onClick,
}: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.row}>
          <TextField placeholder={'Type to search'} onChange={onSearch} fullWidth />
        </div>
        <MenuList className={classes.menu}>
          {sectionTitle && options.length > 0 && (
            <Typography variant="body2" className={classes.sectionTitle}>
              {sectionTitle}
            </Typography>
          )}
          {options.map((option, i) => (
            <MenuItem key={`${option.type}-${i}`} onClick={() => onClick(option)}>
              <TruncateItemWithTooltip option={option} key={`truncated-${option.type}-${i}`} />
            </MenuItem>
          ))}
          {sectionTitle && !_isEmpty(secondaryOptions) && (
            <Typography variant="body2" className={classes.sectionTitle}>
              {secondarySectionTitle}
            </Typography>
          )}
          {secondaryOptions &&
            !_isEmpty(secondaryOptions) &&
            secondaryOptions.map((option, i) => (
              <MenuItem key={`${option.type}-${i}`} onClick={() => onClick(option)}>
                <TruncateItemWithTooltip option={option} key={`truncated-${option.type}-${i}`} />
              </MenuItem>
            ))}
        </MenuList>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 377,
  },
  menu: {
    maxHeight: 250,
    overflowY: 'auto',
  },
  row: {
    height: 32,
    paddingLeft: theme.spacing(),
  },
  sectionTitle: {
    fontWeight: theme.typography.fontWeightSemiBold,
  },
}));

export default SearchableInput;
